import {
  type VENDOR_CONFIG_PAYLOAD,
  listen,
  vendorConfigMessage,
  isVendorConfigRequestMessage,
  sendLocal,
} from "@sinch/bus";
import { isBoolean } from "@sinch/feature-flags";
import { useFeatureFlag } from "@sinch/feature-flags/react";
import { useEffect, useCallback } from "react";
import { useIntl } from "react-intl";
import {
  getVendorChecks,
  getVendorConfig,
} from "../portals/messagemedia/vendorConfig";

export const useVendorConfigHandler = () => {
  const intl = useIntl();
  const extensionsV2 = useFeatureFlag("extensionsV2", isBoolean, false);
  const numbersAndChannelsV2 = useFeatureFlag(
    "numbersAndChannelsV2",
    isBoolean,
    false
  );
  const vendorConfig = getVendorConfig();

  const getVendorConfigMessage: () => VENDOR_CONFIG_PAYLOAD =
    useCallback((): VENDOR_CONFIG_PAYLOAD | null => {
      if (!vendorConfig) {
        console.error(
          "Couldn't get VendorConfig message - Vendor Config not found!"
        );
        return null;
      }

      const collapsedLogoValue = {
        src: vendorConfig.compactLogoUrl,
        alt: intl.formatMessage({ id: "logo" }),
      };
      const logoValue = {
        src: vendorConfig.logoUrl,
        alt: intl.formatMessage({ id: "logo" }),
      };

      return {
        ...getVendorChecks(),
        supportLink: vendorConfig.helpCenterUrl,
        ...(collapsedLogoValue && { logoCollapsed: collapsedLogoValue }),
        ...(logoValue && { logo: logoValue }),
        extensionsV2,
        numbersAndChannelsV2,
      };
    }, [extensionsV2, numbersAndChannelsV2, intl, vendorConfig]);

  useEffect(() => {
    const unsub = listen(() => {
      sendLocal(vendorConfigMessage(getVendorConfigMessage()));
    }, isVendorConfigRequestMessage);

    return unsub;
  }, [getVendorConfigMessage]);
};
